module.exports = __webpack_public_path__ + "static/media/een-logo-white.94b118c0.png";